/* eslint-disable no-underscore-dangle */
import axios from "axios";

export const axiosGuest = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 36000,
  headers: {
    "Content-Type": "application/json"
  }
});
